class PromoPopup {
  constructor(container) {
    this.container = container;
    this.popupModal = container.querySelector(".sign-up-popup-modal");
    this.overlay = container.querySelector(".sign-up-popup-overlay");
    this.closeButton = this.popupModal.querySelector(".popup-modal__close");
    this.dismissButton = this.popupModal.querySelector(
      ".popup-modal__dismiss-btn"
    );

    this.form = this.popupModal.querySelector("form.newsletter-form");
    this.emailInput = this.form?.querySelector('input[type="email"]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.formError = this.form?.querySelector(".newsletter-form__message");

    this.successModal = container.querySelector(".success-popup-modal");
    this.successOverlay = container.querySelector(".success-popup-overlay");
    this.copyButton = this.successModal?.querySelector(
      ".popup-modal__copy-btn"
    );
    this.copySuccessMsg = this.successModal?.querySelector(
      ".popup-modal__success-msg"
    );
    this.successCloseButton = this.successModal?.querySelector(
      ".popup-modal__close"
    );
    this.successDismissButton = this.successModal?.querySelector(
      ".popup-modal__dismiss-btn"
    );

    const state = container.querySelector(".promo-popup-state");
    this.posted = state?.dataset.posted === "true";
    this.hasErrors = state?.dataset.errors === "true";

    this.sectionId = this.popupModal.dataset.sectionId;
    this.testMode = this.popupModal.dataset.testMode === "true";
    this.delaySeconds = parseInt(this.popupModal.dataset.delaySeconds);
    this.delayDays = parseInt(this.popupModal.dataset.delayDays);
    this.displayTimer = this.popupModal.dataset.displayTimer === "true";
    this.timerDuration = parseFloat(this.popupModal.dataset.timerDuration) * 60;

    this.minutesElement = this.popupModal.querySelector(
      ".popup-modal__timer__minutes"
    );
    this.secondsElement = this.popupModal.querySelector(
      ".popup-modal__timer__seconds"
    );

    this.storageKey = `promo-popup-${window.location.host}-${this.sectionId}`;

    this.init();
  }

  init() {
    this.setupEventListeners();
    if (this.form) {
      this.setupFormSubmission();
    }

    // Just signed up: Shopify saved the email and the page reloaded with the
    // success state. Show the code and don't show the sign-up popup again.
    if (this.posted) {
      this.remember(365);
      this.showSuccessPopup();
      return;
    }

    // The email was rejected: reopen the popup so the error is visible.
    if (this.hasErrors) {
      this.showPopup();
      return;
    }

    if (this.testMode) {
      this.showPopup();
      return;
    }

    this.checkAndShowPopup();
  }

  setupEventListeners() {
    this.closeButton.addEventListener("click", () => this.closePopup());
    if (this.dismissButton) {
      this.dismissButton.addEventListener("click", () => this.closePopup());
    }
    this.overlay.addEventListener("click", () => this.closePopup());

    if (this.successModal) {
      if (this.copyButton) {
        this.copyButton.addEventListener("click", () => this.handleCopyCode());
      }
      if (this.successCloseButton) {
        this.successCloseButton.addEventListener("click", () =>
          this.closeSuccessPopup()
        );
      }
      if (this.successDismissButton) {
        this.successDismissButton.addEventListener("click", () =>
          this.closeSuccessPopup()
        );
      }
      if (this.successOverlay) {
        this.successOverlay.addEventListener("click", () =>
          this.closeSuccessPopup()
        );
      }
    }
  }

  // Let the browser submit the Shopify customer form normally, so the email
  // is saved as a subscriber. The code is only revealed after Shopify accepts it.
  setupFormSubmission() {
    this.form.addEventListener("submit", () => {
      if (this.submitButton) this.submitButton.disabled = true;
      try {
        localStorage.setItem(
          "promo-bar-subscribed-" + window.location.host,
          JSON.stringify({ subscribed: true })
        );
      } catch (e) {}
    });
  }

  remember(days) {
    if (this.testMode) return;
    try {
      const next = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
      localStorage.setItem(
        this.storageKey,
        JSON.stringify({ next_display_date: next.toISOString(), dismissed: false })
      );
    } catch (e) {}
  }

  checkAndShowPopup() {
    try {
      if (localStorage.getItem("promo-bar-subscribed-" + window.location.host)) {
        return;
      }
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        const { next_display_date } = JSON.parse(stored);
        if (new Date(next_display_date) > new Date()) {
          return;
        }
      }
    } catch (e) {}

    setTimeout(() => {
      this.showPopup();
    }, this.delaySeconds * 1000);
  }

  showPopup() {
    this.popupModal.classList.add("popup-modal--active");
    this.overlay.classList.add("popup-overlay--active");

    if (this.displayTimer) {
      this.startTimer();
    }
  }

  closePopup() {
    this.popupModal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
    this.remember(this.delayDays);
  }

  showSuccessPopup() {
    if (this.successModal) {
      this.popupModal.classList.remove("popup-modal--active");
      this.overlay.classList.remove("popup-overlay--active");
      this.successModal.classList.add("popup-modal--active");
      this.successOverlay.classList.add("popup-overlay--active");
    }
  }

  closeSuccessPopup() {
    if (this.successModal) {
      this.successModal.classList.remove("popup-modal--active");
      this.successOverlay.classList.remove("popup-overlay--active");
    }
  }

  async handleCopyCode() {
    const discountCode = this.successModal?.querySelector(
      "#DiscountCode--" + this.sectionId
    );
    if (!discountCode) return;

    try {
      await navigator.clipboard.writeText(discountCode.value);
    } catch (err) {
      discountCode.select();
      document.execCommand("copy");
    }

    if (this.copySuccessMsg) {
      this.copySuccessMsg.style.display = "block";
      setTimeout(() => {
        this.copySuccessMsg.style.display = "none";
      }, 3000);
    }
  }

  showFormError(message) {
    if (this.formError) {
      this.formError.textContent = message;
      this.formError.style.display = "block";
      setTimeout(() => {
        this.formError.style.display = "none";
      }, 5000);
    }
  }

  startTimer() {
    let timeLeft = this.timerDuration;

    const updateTimer = () => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      this.minutesElement.textContent = minutes.toString().padStart(2, "0");
      this.secondsElement.textContent = seconds.toString().padStart(2, "0");

      if (timeLeft > 0) {
        timeLeft--;
        setTimeout(updateTimer, 1000);
      } else {
        this.closePopup();
      }
    };

    updateTimer();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(
    '[data-section-type="newsletter-popup"]'
  );
  sections.forEach((section) => {
    new PromoPopup(section.closest("section, .shopify-section"));
  });
});
